import {
  Button,
} from "@chakra-ui/react";
import styles from "../../styles/modules/Btn.module.css";


export default function Btn({text, clickEvent, 
                            fontWeight='var(--panda-main-font-weight)', 
                            fontSize = "15px", color='white', 
                            backgroundColor = "var(--panda-main-color)!important", 
                            borderRadius ="4px", 
                            classProp =''
                          }){

  return(
    <>
      <Button 
          className={ !classProp ? styles.basic : classProp} 
          onClick={() => clickEvent()}
          backgroundColor={backgroundColor}
          color={color}
          fontSize = {fontSize}
          borderRadius={borderRadius}
          fontWeight={fontWeight}
          >
            {text}
      </Button>
    </>
  )
}